import OnboardingContainer from './OnboardingContainer';
export default OnboardingContainer;
